import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    const path = window.location.pathname;
    window.history.replaceState(null, "", path);
    if (!sessionId) return navigate("/login", { replace: true });
    api
      .post("/auth/session", { session_id: sessionId })
      .then(async ({ data }) => {
        await checkAuth();
        toast.success(`Welcome, ${data.name || "mechanic"}`);
        navigate(path.startsWith("/join/") ? path : "/app", { replace: true });
      })
      .catch(() => {
        setUser(false);
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser, checkAuth]);

  return <div className="min-h-screen bg-background" data-testid="auth-callback" />;
};

const FREE_PATHS = ["/app/billing"];

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const locked = user && !user.access?.has_access && !FREE_PATHS.includes(pathname);
  const forbidden = user && roles && !(roles.includes(user.shop_role) || (roles.includes("admin") && user.role === "admin"));
  useEffect(() => {
    if (user === false) navigate(`/login?next=${encodeURIComponent(pathname)}`, { replace: true });
    else if (locked) navigate("/app/billing", { replace: true });
    else if (forbidden) navigate("/app", { replace: true });
  }, [user, navigate, locked, forbidden, pathname]);
  if (!user || locked || forbidden)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="h-1 w-40 bg-secondary overflow-hidden rounded">
          <div className="h-full w-1/4 bg-primary scanbar" />
        </div>
      </div>
    );
  return children;
};
